export const sum_portfolio = `subscription sum_portfolio{
    sum_portfolio{
        last_update
        sum
        portfolio{
            name
            value
            percent
        }
    }
}`;
